import {
    FETCH_CONSUMER_GROUP_SUCCESS,
    FETCH_CONSUMER_GROUP_ITEM_SUCCESS,

    CONSUMER_GROUP_REQUEST_LOADING,
    CONSUMER_GROUP_REQUEST_ERRORS,
} from "api/menu/master-files/consumer-groups/actions";

const initialState = {
    loading: false,
    errors: [],

    consumerGroups: [],
    consumerGroupItem: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CONSUMER_GROUP_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case CONSUMER_GROUP_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_CONSUMER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                consumerGroups: action.payload
            };
        case FETCH_CONSUMER_GROUP_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                consumerGroupItem: action.payload
            };
        default:
            return state;
    }
}
